import React, { useContext } from "react";
import { graphql } from "gatsby";
import { Accounts as AccountsComponent } from "@zempler/theme/src/components/accounts/Accounts";
import { PageContext } from "../../../../context/pageContext";

export const Accounts = ({ data, ...rest }) => {
  const { pageUrl } = useContext(PageContext)!;

  return <AccountsComponent {...data} pageUrl={pageUrl} />;
};

export const AccountsQuery = graphql`
  fragment Accounts on UMBRACO_AccountsComponentType {
    displayCostInColourBlock: showBenefits
    accounts: accountItems {
      name: accountName
      subHeading
      secondarySubheading
      monthlyCost
      details {
        detail
        heading
      }
      benefits {
        detail
        heading
        included
      }
      image {
        image {
          ...Image
        }
      }
      allFeesLink {
        ...Link
      }
      primaryButton {
        ...Link
      }
      secondaryLink {
        ...Link
      }
      shortName
      colour
      accountFeeHeading
      accountFeeSubHeading
      fees {
        detail
        extraDetail
        heading
      }
      limits {
        detail: description
        heading
      }
      buttonColour
      feeSmallPrint
    }
  }
`;
